import styles from "../views/pages/PaymentForm.module.css"
import classNames from 'classnames';

const CryptoOption = ({icon, name, fullname, cryptoCurrency, setCryptoCurrency}) => {
    const setCryptoCurrency_ = (e) => {
        setCryptoCurrency(e.target.value)
    }
    return ( 
        <div className={styles.cryptoOption}>
                                <input type="radio" id={name.toLowerCase()} name="crypto-currency" value={name} onChange={setCryptoCurrency_} checked={cryptoCurrency === name}/>
                                <label htmlFor={name.toLowerCase()}>
                                    <div className={classNames(styles.cryptoIcon, name.toLowerCase())}>{icon}</div>
                                    <div className={styles.cryptoName}>{name}</div>
                                    <div className={styles.cryptoFullName}>{fullname}</div>
                                </label>
                            </div>
    )
}

export default CryptoOption